import { getAPIClient } from './client';

export interface FilterFacetOption {
  value: string;
  count: number;
}

export interface OpportunityFilterOptionsResponse {
  project_id: string;
  total_matching: number;
  provinces: FilterFacetOption[];
  cities: FilterFacetOption[];
  clients: FilterFacetOption[];
  countries: FilterFacetOption[];
}

export interface OpportunityFilterOptionsParams {
  project_id: string;
  province?: string;
  city?: string;
  client?: string;
  country?: string;
  geographic_zone?: string;
}

export async function getOpportunityFilterOptions(
  params: OpportunityFilterOptionsParams
): Promise<OpportunityFilterOptionsResponse> {
  const client = getAPIClient();
  return client.get<OpportunityFilterOptionsResponse>('/api/opportunities/filter-options', {
    params: {
      project_id: params.project_id,
      province: params.province && params.province !== 'all' ? params.province : undefined,
      city: params.city && params.city !== 'all' ? params.city : undefined,
      client: params.client && params.client !== 'all' ? params.client : undefined,
      country: params.country && params.country !== 'all' ? params.country : undefined,
      geographic_zone:
        params.geographic_zone && params.geographic_zone !== 'all'
          ? params.geographic_zone
          : undefined,
    },
  });
}
